import React from 'react'
import AddBoxIcon from '@material-ui/icons/AddBox'
import styled from '@emotion/styled'

type Props = {
  onClick: () => void
}

const StyledPlusButton = styled(AddBoxIcon)`
  font-size: 50px !important;
  fill: #289c91 !important;
  & :hover {
    fill: #f0535d !important;
    cursor: pointer;
  }
`

const PlusIconButton = (props: Props) => <StyledPlusButton {...props} onClick={props.onClick} />

export default PlusIconButton
